import { createVueApp } from '../utils/create-vue-app';

/* Each component is dynamically imported so it's only downloaded/parsed when
 * its mount element actually exists on the page, instead of bundling all
 * components into the main script for every page. */
const componentLoaders = [
  { name: 'Blobs', loader: () => import('../../vue/components/Blobs/Blobs.vue'), ssr: false },
  { name: 'CredentialList', loader: () => import('../../vue/components/Credentials/CredentialList.vue'), ssr: false },
  { name: 'CertificateHolderList', loader: () => import('../../vue/components/Credentials/CertificateHolderList.vue'), ssr: false },
  { name: 'HeroCollage', loader: () => import('../../vue/components/Hero/HeroCollage.vue'), ssr: false },
  { name: 'InnovationsList', loader: () => import('../../vue/components/Innovations/InnovationsList.vue'), ssr: false },
  { name: 'InstructorsFeed', loader: () => import('../../vue/components/InstructorsFeed/InstructorsFeed.vue'), ssr: false },
  { name: 'JobsFeed', loader: () => import('../../vue/components/JobsFeed/JobsFeed.vue'), ssr: false },
  { name: 'MegaMenu', loader: () => import('../../vue/components/MegaMenu/MegaMenu.vue'), ssr: false },
  { name: 'MosaicFeedGrid', loader: () => import('../../vue/components/MosaicFeedGrid/MosaicFeedGrid.vue'), ssr: true },
  { name: 'OurProcess', loader: () => import('../../vue/components/OurProcess/OurProcess.vue'), ssr: false },
  { name: 'PartnerList', loader: () => import('../../vue/components/Partners/PartnerList.vue'), ssr: false },
  { name: 'PeopleCarousel', loader: () => import('../../vue/components/PeopleCarousel/PeopleCarousel.vue'), ssr: false },
  { name: 'ProjectList', loader: () => import('../../vue/components/ProjectList/ProjectList.vue'), ssr: false },
  { name: 'PublicationList', loader: () => import('../../vue/components/PublicationList/PublicationList.vue'), ssr: false },
  { name: 'ResearchTopics', loader: () => import('../../vue/components/ResearchTopics/ResearchTopics.vue'), ssr: false },
  { name: 'Rolodex', loader: () => import('../../vue/components/Rolodex/Rolodex.vue'), ssr: false },
  { name: 'SearchPage', loader: () => import('../../vue/components/Search/SearchPage.vue'), ssr: false },
  { name: 'StoryScroller', loader: () => import('../../vue/components/StoryScroller/StoryScroller.vue'), ssr: false },
  { name: 'TrainingList', loader: () => import('../../vue/components/Training/TrainingList.vue'), ssr: false },
  { name: 'TypedTable', loader: () => import('../../vue/components/TypedTable/TypedTable.vue'), ssr: false },
];

/* Mount components with props from data attributes */
for (const { name, loader, ssr } of componentLoaders) {
  const dataVueId = name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  createVueApp(`[data-vue-id="${dataVueId}"]`, loader, ssr);
}

